export default __webpack_public_path__ + "static/media/Keypad-Button.044770ee.svg";